import React from "react";
import { notification } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

const SuccessToast = (message, description, pauseOnHover) => {
  notification.open({
    message: message,
    description: description,
    icon: <CheckCircleOutlined style={{ color: "green" }} />,
  });
};

const ErrorToast = (message, description) => {
  notification.open({
    message: message,
    description: description,
    icon: <CloseCircleOutlined style={{ color: "red" }} />,
  });
};

const WarningToast = (message, description, pauseOnHover) => {
  notification.open({
    message: message,
    description: description,
    icon: <ExclamationCircleOutlined style={{ color: "#F96E2A" }} />,
  });
};

const ShowInputError = ({ errorMessage }) => {
  if (!errorMessage) return null;
  return <span style={{ color: "red", fontSize: "14px" }}>{errorMessage}</span>;
};

export { SuccessToast, ErrorToast, ShowInputError, WarningToast };
